import React, { useCallback, useState } from 'react';
import styled from 'astroturf/react';

import * as arbitraryEvents from 'js/core_webpack/arbitrary_events';

import RatingBase, { StarValue } from './Rating';
import _Container from "RatingCard-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/RatingCard/RatingCard.tsx?styleId=Container";
import _MessageContainer from "RatingCard-MessageContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/RatingCard/RatingCard.tsx?styleId=MessageContainer";
import _Message from "RatingCard-Message.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/RatingCard/RatingCard.tsx?styleId=Message";
import _Note from "RatingCard-Note.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/RatingCard/RatingCard.tsx?styleId=Note";
import _Rating from "RatingCard-Rating.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/RatingCard/RatingCard.tsx?styleId=Rating";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const MessageContainer = /*#__PURE__*/styled("div", null, {
  displayName: "MessageContainer",
  styles: _MessageContainer
});

const Message = /*#__PURE__*/styled("p", null, {
  displayName: "Message",
  styles: _Message
});

const Note = /*#__PURE__*/styled("p", null, {
  displayName: "Note",
  styles: _Note
});

const Rating = /*#__PURE__*/styled(RatingBase, null, {
  displayName: "Rating",
  styles: _Rating
});

type Props = {
  className?: string;
  newsType: string;
  newsId: string | number;
  reason?: string;
  variant?: 'default' | 'corex';
};

const RatingCard: React.FC<Props> = ({
  className,
  newsType,
  newsId,
  reason,
  variant = 'default',
}) => {
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [stars, setStars] = useState<StarValue | undefined>(undefined);

  const onChange = useCallback(
    (value: StarValue) => {
      setSubmitted(true);
      setStars(value);
      arbitraryEvents.write('SocialRecommendationRating', {
        rating: value,
        news_type: newsType,
        news_id: newsId,
        reason: reason || '',
      });
    },
    [newsId, newsType, reason],
  );

  const message = submitted ? (
    <Message>Thanks for your feedback</Message>
  ) : (
    <>
      <Message>How relevant is this for you?</Message>
      <Note>Your response is private</Note>
    </>
  );

  return (
    <Container className={className} variant={variant}>
      <MessageContainer>{message}</MessageContainer>
      <Rating stars={stars} onChange={onChange} />
    </Container>
  );
};

export default RatingCard;
